module.exports = __webpack_public_path__ + "static/media/hand-holding-seedling.f477f288.svg";